function DashboardActiveMainFuelSystem({value}) {
    return (
        <div className="space-y-3">
            <h2 className="text-xs font-bold uppercase text-[#92adc9] tracking-wider">Fuel System</h2>
            <div className="grid grid-cols-2 gap-3">
                <div className="rounded-lg bg-[#233648]/30 p-2 border border-[#324d67]/30">
                    <span className="text-[9px] uppercase text-[#92adc9]">Remaining</span>
                    <p className="text-lg font-bold">{value.fuel.toFixed(1)} L</p>
                </div>
                <div className="rounded-lg bg-[#233648]/30 p-2 border border-[#324d67]/30">
                    <span className="text-[9px] uppercase text-[#92adc9]">Laps Est.</span>
                    <p className="text-lg font-bold text-acc-yellow">{(Math.floor(value["fuel-estimated-laps"] * 10) / 10).toFixed(1)}</p>
                </div>
                <div className="col-span-2 rounded-lg bg-[#233648]/30 p-2 border border-[#324d67]/30">
                    <div className="flex justify-between text-[9px] uppercase text-[#92adc9] mb-1">
                        <span>Consumption / Lap</span>
                        <span className="text-white">{(Math.floor(value["fuel-x-lap"] * 100) / 100).toFixed(2)} L</span>
                    </div>
                    <div className="w-full bg-[#111a22] h-1.5 rounded-full overflow-hidden">
                        <div className="bg-primary h-full" style={{width: Math.floor((value["fuel-x-lap"]/20) * 100) +'%'}}></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DashboardActiveMainFuelSystem;